<template>
  <div class="settings">
    <h1>{{ $t("langcfg.txtReport") }}</h1>
    <el-collapse
      v-model="activeName"
      accordion
      @change="collapseItemChanged"
      :style="`min-width: ${isDE ? '1040px' : isIT ? '1000px' : '840px'}`"
    >
      <el-collapse-item :title="$t('langcfg.txtHospitalInfo')" name="general">
        <div class="print-content" :style="`width: ${isDE ? '1000px' : '800px'}`">
          <el-form label-position="left" label-width="250px">
            <el-form-item :label="`${$t('langcfg.txtHospitalName')}:`">
              <el-input
                v-model="printSettings.general.hospitalname"
                @click.native.stop.prevent="handleClick('hospitalname')"
                @touchend.native.stop.prevent="handleClick('hospitalname')"
              >
              </el-input>
            </el-form-item>
            <el-form-item :label="`${$t('langcfg.txtCheckDoctor')}:`">
              <el-input
                v-model="printSettings.general.checkdoctor"
                @click.native.stop.prevent="handleClick('checkdoctor')"
                @touchend.native.stop.prevent="handleClick('checkdoctor')"
              >
              </el-input>
            </el-form-item>
            <el-form-item :label="`${$t('langcfg.txtHospitalTel')}:`">
              <el-input
                v-model="printSettings.general.hospitaltel"
                @click.native.stop.prevent="handleClick('hospitaltel')"
                @touchend.native.stop.prevent="handleClick('hospitaltel')"
              >
              </el-input>
            </el-form-item>
            <el-form-item :label="`${$t('langcfg.txtHospitalAddress')}:`">
              <el-input
                v-model="printSettings.general.hospitaladdr"
                @click.native.stop.prevent="handleClick('hospitaladdr')"
                @touchend.native.stop.prevent="handleClick('hospitaladdr')"
              >
              </el-input>
            </el-form-item>
            <el-form-item :label="`${$t('langcfg.txtHospitalLogo')}:`">
              <div style="display: flex">
                <el-input v-model="logo" @click.native="chooseLogo"></el-input>
                <div @click="chooseLogo" size="small" class="el-icon-folder-opened logo-icon"></div>
                <div @click="deleteLogo" size="small" class="el-icon-delete logo-icon"></div>
              </div>
            </el-form-item>
            <el-form-item label="">
              <div style="text-align: left; font-size: 20px">
                <label style="color: white">{{ $t("langcfg.txtLogoTip") }}</label>
              </div>
            </el-form-item>
            <el-form-item v-if="false" :label="`${$t('langcfg.txtPaperType')}:`">
              <select class="print-paper" v-model="paper">
                <option v-for="item in papes" :key="item.key" value="A4" class="print-paper-option">
                  {{ item.label }}
                </option>
              </select>
            </el-form-item>
          </el-form>
        </div>
      </el-collapse-item>
      <el-collapse-item :title="$t('langcfg.txtAnonymous')" name="anonymous">
        <el-form
          style="margin-left: 50px"
          :label-width="`${isIT ? '350px' : '200px'}`"
          label-position="left"
        >
          <el-form-item :label="`${$t('langcfg.txtPatientInfo')}:`">
            <el-radio-group
              v-model="printSettings.general.anonymous.patientinfo"
              text-color="#00ff00"
              class="anonymous-containner"
            >
              <el-radio
                :label="true"
                text-color="#00ff00"
                @change="changeSwitch($event, 'patientinfo')"
                style="width: 200px; margin-left: 20px; margin-top: 10px"
              >
                {{ $t("langcfg.txtShow") }}</el-radio
              >
              <el-radio
                :label="false"
                text-color="#00ff00"
                @change="changeSwitch($event, 'patientinfo')"
                style="width: 200px; margin-left: 20px; margin-top: 10px"
              >
                {{ $t("langcfg.txtNotShow") }}</el-radio
              >
            </el-radio-group>
          </el-form-item>
          <el-form-item
            :label="`${isEN ? $t('langcfg.txtDoctorName') : $t('langcfg.txtCheckDoctor')}:`"
          >
            <el-radio-group
              v-model="printSettings.general.anonymous.checkdoctor"
              text-color="#00ff00"
              class="anonymous-containner"
            >
              <el-radio
                :label="true"
                text-color="#00ff00"
                @change="changeSwitch($event, 'checkdoctor')"
                style="width: 200px; margin-left: 20px; margin-top: 10px"
              >
                {{ $t("langcfg.txtShow") }}</el-radio
              >
              <el-radio
                :label="false"
                text-color="#00ff00"
                @change="changeSwitch($event, 'checkdoctor')"
                style="width: 200px; margin-left: 20px; margin-top: 10px"
              >
                {{ $t("langcfg.txtNotShow") }}</el-radio
              >
            </el-radio-group>
          </el-form-item>
          <el-form-item :label="`${$t('langcfg.txtPrintDate')}:`">
            <el-radio-group
              v-model="printSettings.general.anonymous.printdate"
              text-color="#00ff00"
              class="anonymous-containner"
            >
              <el-radio
                :label="true"
                text-color="#00ff00"
                @change="changeSwitch($event, 'printdate')"
                style="width: 200px; margin-left: 20px; margin-top: 10px"
              >
                {{ $t("langcfg.txtShow") }}</el-radio
              >
              <el-radio
                :label="false"
                text-color="#00ff00"
                @change="changeSwitch($event, 'printdate')"
                style="width: 200px; margin-left: 20px; margin-top: 10px"
              >
                {{ $t("langcfg.txtNotShow") }}</el-radio
              >
            </el-radio-group>
          </el-form-item>
        </el-form>
      </el-collapse-item>
      <el-collapse-item :title="$t('langcfg.txtFileFormat')" name="fileformat">
        <el-form style="margin-left: 50px" label-width="200px" label-position="left">
          <el-form-item :label="`${$t('langcfg.txtFormat')}:`">
            <el-radio-group
              v-model="printSettings.general.format"
              text-color="#00ff00"
              class="anonymous-containner"
            >
              <div>
                <el-radio
                  :label="'.pdf'"
                  text-color="#00ff00"
                  @change="changePDF2ImageCfg"
                  style="width: 200px; margin-left: 20px; margin-top: 10px"
                >
                  .PDF</el-radio
                >
                <el-radio
                  :label="'.jpg'"
                  text-color="#00ff00"
                  @change="changePDF2ImageCfg"
                  style="width: 200px; margin-left: 20px; margin-top: 20px"
                >
                  .JPEG</el-radio
                >
              </div>
              <div>
                <el-radio
                  :label="'.png'"
                  text-color="#00ff00"
                  @change="changePDF2ImageCfg"
                  style="width: 200px; margin-left: 20px; margin-top: 10px"
                >
                  .PNG</el-radio
                >
                <el-radio
                  :label="'.bmp'"
                  text-color="#00ff00"
                  @change="changePDF2ImageCfg"
                  style="width: 200px; margin-left: 20px; margin-top: 20px"
                >
                  .BMP</el-radio
                >
              </div>
            </el-radio-group>
          </el-form-item>
          <el-form-item :label="`${$t('langcfg.txtReportPages')}:`">
            <el-radio-group
              v-model="printSettings.general.singlepage"
              text-color="#00ff00"
              class="anonymous-containner"
            >
              <el-radio
                :label="true"
                :disabled="radioDisabled"
                text-color="#00ff00"
                @change="changePDF2ImageCfg"
                style="width: 200px; margin-left: 20px; margin-top: 10px"
              >
                {{ $t("langcfg.txtSinglePage") }}</el-radio
              >
              <el-radio
                :label="false"
                :disabled="radioDisabled"
                text-color="#00ff00"
                @change="changePDF2ImageCfg"
                style="width: 200px; margin-left: 20px; margin-top: 10px"
              >
                {{ $t("langcfg.txtMutiPages") }}</el-radio
              >
            </el-radio-group>
          </el-form-item>
        </el-form>
      </el-collapse-item>
      <el-collapse-item
        :title="$t('langcfg.txtTopography')"
        name="topography"
        v-if="isTopographyEnabled"
      >
        <div class="print-content" :style="`width: ${isDE ? '1000px' : '800px'}`">
          <el-form label-position="left" :label-width="isDE ? '350px' : isIT ? '420px' : '300px'">
            <el-form-item :label="`${$t('langcfg.txtReportTitle')}:`">
              <el-input
                v-model="printSettings.general.title_topograpy"
                @click.native.stop.prevent="handleClick('title_topograpy')"
                @touchend.native.stop.prevent="handleClick('title_topograpy')"
              >
              </el-input>
            </el-form-item>
            <el-form-item :label="`${$t('langcfg.txtFourMapsTitle')}:`">
              <el-input
                v-model="printSettings.topography.four_maps_title"
                @click.native.stop.prevent="handleTopoClick('four_maps_title')"
                @touchend.native.stop.prevent="handleTopoClick('four_maps_title')"
              >
              </el-input>
            </el-form-item>
            <el-form-item :label="`${$t('langcfg.txtHeightFAndTFSQTitle')}:`">
              <el-input
                v-model="printSettings.topography.heightf_tfsq_title"
                @click.native.stop.prevent="handleTopoClick('heightf_tfsq_title')"
                @touchend.native.stop.prevent="handleTopoClick('heightf_tfsq_title')"
              >
              </el-input>
            </el-form-item>
            <el-form-item :label="`${$t('langcfg.txtZernikeTitle')}:`">
              <el-input
                v-model="printSettings.topography.zernike_title"
                @click.native.stop.prevent="handleTopoClick('zernike_title')"
                @touchend.native.stop.prevent="handleTopoClick('zernike_title')"
              >
              </el-input>
            </el-form-item>
            <el-form-item :label="`${$t('langcfg.txtKeratoconusTitle')}:`">
              <el-input
                v-model="printSettings.topography.keratoconus_title"
                @click.native.stop.prevent="handleTopoClick('keratoconus_title')"
                @touchend.native.stop.prevent="handleTopoClick('keratoconus_title')"
              >
              </el-input>
            </el-form-item>
            <el-form-item :label="`${$t('langcfg.txtPupilCorneaTitle')}:`">
              <el-input
                v-model="printSettings.topography.pupil_cornea_title"
                @click.native.stop.prevent="handleTopoClick('pupil_cornea_title')"
                @touchend.native.stop.prevent="handleTopoClick('pupil_cornea_title')"
              >
              </el-input>
            </el-form-item>
            <el-form-item :label="`${$t('langcfg.txtFourierAnalysisTitle')}:`">
              <el-input
                v-model="printSettings.topography.fourier_analysis_title"
                @click.native.stop.prevent="handleTopoClick('fourier_analysis_title')"
                @touchend.native.stop.prevent="handleTopoClick('fourier_analysis_title')"
              >
              </el-input>
            </el-form-item>
            <el-form-item :label="`${$t('langcfg.txtCompare2RecordsTitle')}:`">
              <el-input
                v-model="printSettings.topography.compare2records_title"
                @click.native.stop.prevent="handleTopoClick('compare2records_title')"
                @touchend.native.stop.prevent="handleTopoClick('compare2records_title')"
              >
              </el-input>
            </el-form-item>
            <el-tabs type="card" v-model="tabActiveName" @tab-click="tabClick" :stretch="true">
              <el-tab-pane :label="$t('langcfg.txtMinoReport')" name="mino">
                <div style="margin-top: 10px" v-for="(item, index) in reportNames" :key="index">
                  <span style="font-size: 25px">{{ index + 1 }}. &nbsp;</span>

                  <el-select
                    @change="selectedChanged"
                    v-model="reportNameSelections[`selection${index + 1}`].value"
                    style="margin-top: 15px"
                  >
                    <el-option
                      v-for="item in reportNameSelections[`selection${index + 1}`].selections"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                  <span
                    class="el-icon-circle-close"
                    style="font-size: 30px; margin-left: 10px"
                    @click="clear(index + 1)"
                  ></span>
                </div>
              </el-tab-pane>
              <el-tab-pane :label="$t('langcfg.txtBinoReport')" name="bino">
                <div
                  style="margin-top: 10px"
                  v-for="(item, index) in reportNames_bino"
                  :key="index"
                >
                  <span style="font-size: 25px">{{ index + 1 }}. &nbsp;</span>

                  <el-select
                    @change="selectedChangedBino"
                    v-model="reportNameSelections_bino[`selection${index + 1}`].value"
                    style="margin-top: 15px"
                  >
                    <el-option
                      v-for="item in reportNameSelections_bino[`selection${index + 1}`].selections"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                  <span
                    class="el-icon-circle-close"
                    style="font-size: 30px; margin-left: 10px"
                    @click="clearBino(index + 1)"
                  ></span>
                </div>
              </el-tab-pane>
            </el-tabs>
          </el-form>
        </div>
      </el-collapse-item>
      <el-collapse-item :title="$t('langcfg.txtDryEye')" name="dryeye" v-if="isDryEyeEnabled">
        <div class="print-content" :style="`width: ${isDE ? '1000px' : '800px'}`">
          <el-form label-position="left" :label-width="isDE ? '350px' : '300px'">
            <el-form-item :label="`${$t('langcfg.txtReportTitle')}:`">
              <el-input
                v-model="printSettings.general.title"
                @click.native.stop.prevent="handleClick('title')"
                @touchend.native.stop.prevent="handleClick('title')"
              >
              </el-input>
            </el-form-item>
            <br />
            <el-form-item :label="$t('langcfg.txtMeibomian') + ':'">
              <el-radio-group v-model="meibomainReportImgSet" @change="changeMeibomain">
                <el-radio :label="0" class="radio-margin" style="margin-top: 12px">{{
                  $t("langcfg.txtOriginalImg")
                }}</el-radio>
                <el-radio :label="1" class="radio-margin">{{
                  $t("langcfg.txtEnhanceImg")
                }}</el-radio>
                <el-radio :label="2" class="radio-margin">{{
                  $t("langcfg.txtContourImg")
                }}</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-form>
        </div>
      </el-collapse-item>
      <el-collapse-item :title="$t('langcfg.txtPrinterSettings')">
        <el-form
          :label-width="isIT ? '340px' : '260px'"
          label-position="left"
          class="print-content"
        >
          <el-form-item :label="$t('langcfg.txtPrintUSB') + ':'">
            <div @click="changePrinter('printer-USB')">
              <input
                type="checkbox"
                style="width: 30px; height: 30px"
                :checked="printConnection === 'printer-USB'"
              />
            </div>
          </el-form-item>
          <br />
          <el-form-item :label="$t('langcfg.txtPrinterBox') + ':'">
            <div @click="changePrinter('printer-BOX')">
              <input
                type="checkbox"
                style="width: 30px; height: 30px"
                :checked="printConnection === 'printer-BOX'"
              />
            </div>
          </el-form-item>
        </el-form>
        <el-button
          style="font-size: 28px; width: 48%; margin-top: 20px"
          type="info"
          @click="execFirefox"
          >{{ $t("langcfg.txtPrinterSettings") }}</el-button
        >
      </el-collapse-item>
    </el-collapse>
  </div>
</template>
<script>
import EVENTS from "../../../bus";
import fileSys from "../../../fileoprators/fileSystem";
import { savePrintSettings, saveSettings } from "../../../settings";
import { PRINTPAPERS } from "../../../shared/consts";
import { objectCopy } from "../../../shared/utils";
import { mapState } from "vuex";
import home from "../../../store/modules/home";
import { License, Message } from "../../../mixins";
import { detectPrinter } from "../../js/printer/print";
import http from "http";
let _activeName = "general";
export default {
  name: "Report",
  data() {
    return {
      printSettings: objectCopy(window.printSettings),
      paper: "A4",
      logo: "",
      activeName: "general",
      tabActiveName: "mino",
      papers: [],
      printConnection: "printer-USB",
      printConnections: {
        wifi: {
          value: "wifi",
          label: this.$t("langcfg.txtWifi")
        },
        usb: {
          value: "usb",
          label: "USB"
        }
      },
      meibomainReportImgSet: 0,
      isDE: false,
      isEN: false,
      isIT: false,
      isPrintSelectorVisible: true,
      reportNameSelections: {
        selection1: {
          value: "",
          selections: [
            {
              label: this.$t("langcfg.txtFourMaps"),
              value: "fourmaps"
            },
            {
              label: this.$t("langcfg.txtHeightF") + "、" + this.$t("langcfg.txtTFSQ"),
              value: "heightfandtfsq"
            },
            {
              label: this.$t("langcfg.txtZernike"),
              value: "zernike"
            },
            {
              label: this.$t("langcfg.txtKeratoconus"),
              value: "keratoconus"
            },
            {
              label: this.$t("langcfg.txtPupilCorneaDiameter"),
              value: "pupilcorneadiameter"
            },
            {
              label: this.$t("langcfg.txtFourierAnalysis"),
              value: "fourieranalysis"
            },
            {
              label: this.$t("langcfg.txtCompare2Records"),
              value: "compare2records"
            }
          ]
        },
        selection2: {
          value: "",
          selections: [
            {
              label: this.$t("langcfg.txtFourMaps"),
              value: "fourmaps"
            },
            {
              label: this.$t("langcfg.txtHeightF") + "、" + this.$t("langcfg.txtTFSQ"),
              value: "heightfandtfsq"
            },
            {
              label: this.$t("langcfg.txtZernike"),
              value: "zernike"
            },
            {
              label: this.$t("langcfg.txtKeratoconus"),
              value: "keratoconus"
            },
            {
              label: this.$t("langcfg.txtPupilCorneaDiameter"),
              value: "pupilcorneadiameter"
            },
            {
              label: this.$t("langcfg.txtFourierAnalysis"),
              value: "fourieranalysis"
            },
            {
              label: this.$t("langcfg.txtCompare2Records"),
              value: "compare2records"
            }
          ]
        },
        selection3: {
          value: "",
          selections: [
            {
              label: this.$t("langcfg.txtFourMaps"),
              value: "fourmaps"
            },
            {
              label: this.$t("langcfg.txtHeightF") + "、" + this.$t("langcfg.txtTFSQ"),
              value: "heightfandtfsq"
            },
            {
              label: this.$t("langcfg.txtZernike"),
              value: "zernike"
            },
            {
              label: this.$t("langcfg.txtKeratoconus"),
              value: "keratoconus"
            },
            {
              label: this.$t("langcfg.txtPupilCorneaDiameter"),
              value: "pupilcorneadiameter"
            },
            {
              label: this.$t("langcfg.txtFourierAnalysis"),
              value: "fourieranalysis"
            },
            {
              label: this.$t("langcfg.txtCompare2Records"),
              value: "compare2records"
            }
          ]
        },
        selection4: {
          value: "",
          selections: [
            {
              label: this.$t("langcfg.txtFourMaps"),
              value: "fourmaps"
            },
            {
              label: this.$t("langcfg.txtHeightF") + "、" + this.$t("langcfg.txtTFSQ"),
              value: "heightfandtfsq"
            },
            {
              label: this.$t("langcfg.txtZernike"),
              value: "zernike"
            },
            {
              label: this.$t("langcfg.txtKeratoconus"),
              value: "keratoconus"
            },
            {
              label: this.$t("langcfg.txtPupilCorneaDiameter"),
              value: "pupilcorneadiameter"
            },
            {
              label: this.$t("langcfg.txtFourierAnalysis"),
              value: "fourieranalysis"
            },
            {
              label: this.$t("langcfg.txtCompare2Records"),
              value: "compare2records"
            }
          ]
        },
        selection5: {
          value: "",
          selections: [
            {
              label: this.$t("langcfg.txtFourMaps"),
              value: "fourmaps"
            },
            {
              label: this.$t("langcfg.txtHeightF") + "、" + this.$t("langcfg.txtTFSQ"),
              value: "heightfandtfsq"
            },
            {
              label: this.$t("langcfg.txtZernike"),
              value: "zernike"
            },
            {
              label: this.$t("langcfg.txtKeratoconus"),
              value: "keratoconus"
            },
            {
              label: this.$t("langcfg.txtPupilCorneaDiameter"),
              value: "pupilcorneadiameter"
            },
            {
              label: this.$t("langcfg.txtFourierAnalysis"),
              value: "fourieranalysis"
            },
            {
              label: this.$t("langcfg.txtCompare2Records"),
              value: "compare2records"
            }
          ]
        },
        selection6: {
          value: "",
          selections: [
            {
              label: this.$t("langcfg.txtFourMaps"),
              value: "fourmaps"
            },
            {
              label: this.$t("langcfg.txtHeightF") + "、" + this.$t("langcfg.txtTFSQ"),
              value: "heightfandtfsq"
            },
            {
              label: this.$t("langcfg.txtZernike"),
              value: "zernike"
            },
            {
              label: this.$t("langcfg.txtKeratoconus"),
              value: "keratoconus"
            },
            {
              label: this.$t("langcfg.txtPupilCorneaDiameter"),
              value: "pupilcorneadiameter"
            },
            {
              label: this.$t("langcfg.txtFourierAnalysis"),
              value: "fourieranalysis"
            },
            {
              label: this.$t("langcfg.txtCompare2Records"),
              value: "compare2records"
            }
          ]
        },
        selection7: {
          value: "",
          selections: [
            {
              label: this.$t("langcfg.txtFourMaps"),
              value: "fourmaps"
            },
            {
              label: this.$t("langcfg.txtHeightF") + "、" + this.$t("langcfg.txtTFSQ"),
              value: "heightfandtfsq"
            },
            {
              label: this.$t("langcfg.txtZernike"),
              value: "zernike"
            },
            {
              label: this.$t("langcfg.txtKeratoconus"),
              value: "keratoconus"
            },
            {
              label: this.$t("langcfg.txtPupilCorneaDiameter"),
              value: "pupilcorneadiameter"
            },
            {
              label: this.$t("langcfg.txtFourierAnalysis"),
              value: "fourieranalysis"
            },
            {
              label: this.$t("langcfg.txtCompare2Records"),
              value: "compare2records"
            }
          ]
        }
      },
      reportNames: [
        {
          label: this.$t("langcfg.txtFourMaps"),
          value: "fourmaps"
        },
        {
          label: this.$t("langcfg.txtHeightF") + "、" + this.$t("langcfg.txtTFSQ"),
          value: "heightfandtfsq"
        },
        {
          label: this.$t("langcfg.txtZernike"),
          value: "zernike"
        },
        {
          label: this.$t("langcfg.txtKeratoconus"),
          value: "keratoconus"
        },
        {
          label: this.$t("langcfg.txtPupilCorneaDiameter"),
          value: "pupilcorneadiameter"
        },
        {
          label: this.$t("langcfg.txtFourierAnalysis"),
          value: "fourieranalysis"
        },
        {
          label: this.$t("langcfg.txtCompare2Records"),
          value: "compare2records"
        }
      ],
      reportName: "",
      reportNameSelections_bino: {
        selection1: {
          value: "",
          selections: [
            {
              label: this.$t("langcfg.txtFourMaps"),
              value: "fourmaps"
            },
            {
              label: this.$t("langcfg.txtHeightF") + "、" + this.$t("langcfg.txtTFSQ"),
              value: "heightfandtfsq"
            },
            {
              label: this.$t("langcfg.txtZernike"),
              value: "zernike"
            },
            {
              label: this.$t("langcfg.txtKeratoconus"),
              value: "keratoconus"
            },
            {
              label: this.$t("langcfg.txtPupilCorneaDiameter"),
              value: "pupilcorneadiameter"
            },
            {
              label: this.$t("langcfg.txtFourierAnalysis"),
              value: "fourieranalysis"
            }
          ]
        },
        selection2: {
          value: "",
          selections: [
            {
              label: this.$t("langcfg.txtFourMaps"),
              value: "fourmaps"
            },
            {
              label: this.$t("langcfg.txtHeightF") + "、" + this.$t("langcfg.txtTFSQ"),
              value: "heightfandtfsq"
            },
            {
              label: this.$t("langcfg.txtZernike"),
              value: "zernike"
            },
            {
              label: this.$t("langcfg.txtKeratoconus"),
              value: "keratoconus"
            },
            {
              label: this.$t("langcfg.txtPupilCorneaDiameter"),
              value: "pupilcorneadiameter"
            },
            {
              label: this.$t("langcfg.txtFourierAnalysis"),
              value: "fourieranalysis"
            }
          ]
        },
        selection3: {
          value: "",
          selections: [
            {
              label: this.$t("langcfg.txtFourMaps"),
              value: "fourmaps"
            },
            {
              label: this.$t("langcfg.txtHeightF") + "、" + this.$t("langcfg.txtTFSQ"),
              value: "heightfandtfsq"
            },
            {
              label: this.$t("langcfg.txtZernike"),
              value: "zernike"
            },
            {
              label: this.$t("langcfg.txtKeratoconus"),
              value: "keratoconus"
            },
            {
              label: this.$t("langcfg.txtPupilCorneaDiameter"),
              value: "pupilcorneadiameter"
            },
            {
              label: this.$t("langcfg.txtFourierAnalysis"),
              value: "fourieranalysis"
            }
          ]
        },
        selection4: {
          value: "",
          selections: [
            {
              label: this.$t("langcfg.txtFourMaps"),
              value: "fourmaps"
            },
            {
              label: this.$t("langcfg.txtHeightF") + "、" + this.$t("langcfg.txtTFSQ"),
              value: "heightfandtfsq"
            },
            {
              label: this.$t("langcfg.txtZernike"),
              value: "zernike"
            },
            {
              label: this.$t("langcfg.txtKeratoconus"),
              value: "keratoconus"
            },
            {
              label: this.$t("langcfg.txtPupilCorneaDiameter"),
              value: "pupilcorneadiameter"
            },
            {
              label: this.$t("langcfg.txtFourierAnalysis"),
              value: "fourieranalysis"
            }
          ]
        },
        selection5: {
          value: "",
          selections: [
            {
              label: this.$t("langcfg.txtFourMaps"),
              value: "fourmaps"
            },
            {
              label: this.$t("langcfg.txtHeightF") + "、" + this.$t("langcfg.txtTFSQ"),
              value: "heightfandtfsq"
            },
            {
              label: this.$t("langcfg.txtZernike"),
              value: "zernike"
            },
            {
              label: this.$t("langcfg.txtKeratoconus"),
              value: "keratoconus"
            },
            {
              label: this.$t("langcfg.txtPupilCorneaDiameter"),
              value: "pupilcorneadiameter"
            },
            {
              label: this.$t("langcfg.txtFourierAnalysis"),
              value: "fourieranalysis"
            }
          ]
        },
        selection6: {
          value: "",
          selections: [
            {
              label: this.$t("langcfg.txtFourMaps"),
              value: "fourmaps"
            },
            {
              label: this.$t("langcfg.txtHeightF") + "、" + this.$t("langcfg.txtTFSQ"),
              value: "heightfandtfsq"
            },
            {
              label: this.$t("langcfg.txtZernike"),
              value: "zernike"
            },
            {
              label: this.$t("langcfg.txtKeratoconus"),
              value: "keratoconus"
            },
            {
              label: this.$t("langcfg.txtPupilCorneaDiameter"),
              value: "pupilcorneadiameter"
            },
            {
              label: this.$t("langcfg.txtFourierAnalysis"),
              value: "fourieranalysis"
            }
          ]
        }
      },
      reportNames_bino: [
        {
          label: this.$t("langcfg.txtFourMaps"),
          value: "fourmaps"
        },
        {
          label: this.$t("langcfg.txtHeightF") + "、" + this.$t("langcfg.txtTFSQ"),
          value: "heightfandtfsq"
        },
        {
          label: this.$t("langcfg.txtZernike"),
          value: "zernike"
        },
        {
          label: this.$t("langcfg.txtKeratoconus"),
          value: "keratoconus"
        },
        {
          label: this.$t("langcfg.txtPupilCorneaDiameter"),
          value: "pupilcorneadiameter"
        },
        {
          label: this.$t("langcfg.txtFourierAnalysis"),
          value: "fourieranalysis"
        }
      ],
      reportName_bino: ""
    };
  },
  mixins: [License, Message],
  created() {
    for (let id in this.printSettings.topography) {
      if (id.indexOf("_title") >= 0 && this.printSettings.topography[id].indexOf("__txt") === 0) {
        this.printSettings.topography[id] = this.$t(
          `langcfg.${this.printSettings.topography[id].replace("__", "")}`
        );
      }
    }
    this.meibomainReportImgSet = this.printSettings.meibomainReportImgSet;
    this.papers = PRINTPAPERS.filter((item) => {
      return item.visible;
    });
    this.tabActiveName = this.printSettings.topography.currentPrintMode;
    this.printConnection = this.printSettings.printConnection;
    this.paper = this.printSettings.general.paper;
    this.logo = this.printSettings.general.hospitallogo;
    this.activeName = _activeName;
  },

  methods: {
    changePrinter(conn) {
      this.printConnection = conn;
      this.printSettings.printConnection = conn;
      this.save();
    },
    changeSwitch(val, key) {
      this.printSettings.general.anonymous[key] = val;
      this.save();
    },
    changePDF2ImageCfg() {
      window.printSettings.general.format = this.printSettings.general.format;
      window.printSettings.general.singlepage = this.printSettings.general.singlepage;
      savePrintSettings(window.printSettings);
    },
    tabClick() {
      this.printSettings.topography.currentPrintMode = this.tabActiveName;
      this.save();
    },
    changeMeibomain(val) {
      this.printSettings.meibomainReportImgSet = val;
      this.meibomainReportImgSet = this.printSettings.meibomainReportImgSet;
      this.save(); // 保存一遍
    },
    execFirefox() {
      let ip = "";
      if (this.printConnection === "printer-USB") {
        ip = "127.0.0.1";
        http.get(`http://127.0.0.1:8000/showPrinterWin?ip=${ip}`, (res) => {});
      } else {
        detectPrinter()
          .then((ip) => {
            http.get(
              `http://127.0.0.1:8000/showPrinterWin?ip=${ip}`,
              (res) => {},
              (e) => {
                this.message(this.$t("langcfg.txtPrinterNotFound"), "error");
                console.log("show printer http-get error", e);
              }
            );
          })
          .catch((e) => {
            console.log("printer err", e);
            this.message(this.$t("langcfg.txtPrinterNotFound"), "error");
          });
      }
    },
    selectPrinter() {
      this.isPrintSelectorVisible = true;
    },
    handleClick(key) {
      let self = this;
      this.$bus.$emit(EVENTS.spreadKeyBoard, self.printSettings.general[key], (value) => {
        self.printSettings.general[key] = value;
        self.printSettings = objectCopy(self.printSettings);
        self.save();
      });
    },
    handleTopoClick(key) {
      let self = this;
      this.$bus.$emit(EVENTS.spreadKeyBoard, self.printSettings.topography[key], (value) => {
        self.printSettings.topography[key] = value;
        self.printSettings = objectCopy(self.printSettings);
        self.save();
      });
    },
    collapseItemChanged(item) {
      let aname = "general";
      if (item === "") {
        if (this.activeName === "general") {
          aname = "topography";
        }
        if (this.activeName === "dryeye") {
          aname = "general";
        }
        if (this.activeName === "topography") {
          aname = "general";
        }
        if (this.activeName === "anonymous") {
          aname = "anonymous";
        }
      }
      _activeName = aname;
      this.activeName = aname;
    },
    changeSel(key) {
      this.printSettings.topography[key] = !this.printSettings.topography[key];
      this.save();
    },
    getDisableStatus(key) {
      let cnt = 0;
      for (const key of ["sagCurv", "tanCurv", "refreactive", "elevation"]) {
        if (this.printSettings.topography.bino.FourMaps[key]) {
          cnt++;
        }
      }
      if (cnt >= 2) {
        return !this.printSettings.topography.bino.FourMaps[key];
      }
    },
    changeBinoSel(key, formaps, disabled = false) {
      if (disabled) return;
      if (formaps) {
        this.printSettings.topography.bino.FourMaps[key] =
          !this.printSettings.topography.bino.FourMaps[key];
      } else {
        this.printSettings.topography.bino[key] = !this.printSettings.topography.bino[key];
      }
      this.save();
    },
    deleteLogo() {
      this.hospitallogo = "";
      this.logo = "";
      this.printSettings.general.hospitallogo = "";
      this.save();
    },
    chooseLogo() {
      global.dialog.showOpenDialog(
        {
          filters: [
            {
              name: "images",
              extensions: ["jpg", "png", "gif", "jpeg"]
            }
          ],
          properties: ["openFile"]
        },
        (paths) => {
          if (paths && paths.length > 0) {
            let filepath = paths[0];
            let img = new Image();
            img.src = filepath;
            img.onload = () => {
              if (img.width > 3852 || img.height > 1378) {
                this.message(this.$t("langcfg.txtImageToLarge"), "error", 2 * 1000);
              } else {
                this.logo = fileSys.getFileBaseName(filepath);
                this.printSettings.general.hospitallogo = this.logo;
                fileSys.copyFile(filepath, fileSys.getCfgPath(this.logo));
                this.save();
              }
            };
          }
        }
      );
    },
    save() {
      window.printSettings = this.printSettings;
      savePrintSettings(window.printSettings);
    },
    clear(index) {
      if (this.reportNames.filter((item) => item !== "").length === 1) {
        return;
      }
      this.reportName = [];
      this.reportNameSelections["selection" + index].value = "";
      this.normalReportName();
    },
    normalReportName() {
      this.reportName = [];
      for (let id in this.reportNameSelections) {
        this.reportName.push(this.reportNameSelections[id].value);
      }
      this.printSettings.topography.reportName = this.reportName;
      this.save();
    },
    selectedChanged() {
      this.normalReportName();
      this.save();
    },
    clearBino(index) {
      if (this.reportNames_bino.filter((item) => item !== "").length === 1) {
        return;
      }
      this.reportName_bino = [];
      this.reportNameSelections_bino["selection" + index].value = "";
      this.normalReportNameBino();
    },
    normalReportNameBino() {
      this.reportName_bino = [];
      for (let id in this.reportNameSelections_bino) {
        this.reportName_bino.push(this.reportNameSelections_bino[id].value);
      }
      this.printSettings.topography.reportName_bino = this.reportName_bino;
      this.save();
    },
    selectedChangedBino() {
      this.normalReportNameBino();
      this.save();
    }
  },
  computed: {
    ...mapState({
      isHasUrl: (state) => home.state.isHasUrl
    }),
    radioDisabled() {
      return this.printSettings.general.format === ".pdf";
    }
  },
  updated() {
    this.isDE = window.settings.language === "de";
    this.isEN = window.settings.language === "en_US";
    this.isIT = window.settings.language === "it";
  },
  beforeDestroy() {
    this.$bus.$off(EVENTS.setPrint);
  },
  mounted() {
    this.isDE = window.settings.language === "de";
    this.isEN = window.settings.language === "en_US";
    this.isIT = window.settings.language === "it";
    if (window.printSettings.topography && window.printSettings.topography.reportName) {
      this.reportName = window.printSettings.topography.reportName;
    } else {
      this.reportName = [
        "fourmaps",
        "heightfandtfsq",
        "zernike",
        "keratoconus",
        "pupilcorneadiameter",
        "fourieranalysis",
        "compare2records"
      ];
      window.printSettings.topography.reportName = this.reportName;
      this.save();
    }
    for (let id in this.reportName) {
      this.reportNameSelections[`selection${parseInt(id) + 1}`].value = this.reportName[id];
    }

    if (window.printSettings.topography && window.printSettings.topography.reportName_bino) {
      this.reportName_bino = window.printSettings.topography.reportName_bino;
    } else {
      this.reportName_bino = [
        "fourmaps",
        "heightfandtfsq",
        "zernike",
        "keratoconus",
        "pupilcorneadiameter",
        "fourieranalysis"
      ];
      window.printSettings.topography.reportName_bino = this.reportName_bino;
      this.save();
    }
    for (let id in this.reportName_bino) {
      this.reportNameSelections_bino[`selection${parseInt(id) + 1}`].value =
        this.reportName_bino[id];
    }
  },
  watch: {
    printSettings: {
      deep: true,
      handler() {
        this.$emit("update");
      }
    },
    reportName: {
      handler: function () {
        if (this.reportName) {
          for (let id in this.reportName) {
            this.reportNameSelections[`selection${parseInt(id) + 1}`].value = this.reportName[id];
          }
        }
        const EXPOPTIONS = [
          {
            label: this.$t("langcfg.txtFourMaps"),
            value: "fourmaps"
          },
          {
            label: this.$t("langcfg.txtHeightF") + "、" + this.$t("langcfg.txtTFSQ"),
            value: "heightfandtfsq"
          },
          {
            label: this.$t("langcfg.txtZernike"),
            value: "zernike"
          },
          {
            label: this.$t("langcfg.txtKeratoconus"),
            value: "keratoconus"
          },
          {
            label: this.$t("langcfg.txtPupilCorneaDiameter"),
            value: "pupilcorneadiameter"
          },
          {
            label: this.$t("langcfg.txtFourierAnalysis"),
            value: "fourieranalysis"
          },
          {
            label: this.$t("langcfg.txtCompare2Records"),
            value: "compare2records"
          }
        ];
        Object.keys(this.reportNameSelections).forEach((key) => {
          this.reportNameSelections[key].selections = EXPOPTIONS.filter((opt) => {
            return (
              this.reportName.indexOf(opt.value) === -1 ||
              this.reportNameSelections[key].value === opt.value
            );
          });
        });
      },
      deep: true,
      immediate: true
    },
    reportName_bino: {
      handler: function () {
        if (this.reportName_bino) {
          for (let id in this.reportName_bino) {
            this.reportNameSelections_bino[`selection${parseInt(id) + 1}`].value =
              this.reportName_bino[id];
          }
        }
        const EXPOPTIONS = [
          {
            label: this.$t("langcfg.txtFourMaps"),
            value: "fourmaps"
          },
          {
            label: this.$t("langcfg.txtHeightF") + "、" + this.$t("langcfg.txtTFSQ"),
            value: "heightfandtfsq"
          },
          {
            label: this.$t("langcfg.txtZernike"),
            value: "zernike"
          },
          {
            label: this.$t("langcfg.txtKeratoconus"),
            value: "keratoconus"
          },
          {
            label: this.$t("langcfg.txtPupilCorneaDiameter"),
            value: "pupilcorneadiameter"
          },
          {
            label: this.$t("langcfg.txtFourierAnalysis"),
            value: "fourieranalysis"
          }
        ];
        Object.keys(this.reportNameSelections_bino).forEach((key) => {
          this.reportNameSelections_bino[key].selections = EXPOPTIONS.filter((opt) => {
            return (
              this.reportName_bino.indexOf(opt.value) === -1 ||
              this.reportNameSelections_bino[key].value === opt.value
            );
          });
        });
        console.log(
          "this.reportNameSelections_bino[key].selections",
          this.reportNameSelections_bino
        );
      },
      deep: true,
      immediate: true
    }
  }
};
</script>
<style lang="less" scoped>
.el-button {
  border: 1px solid gray;
  padding: 10px;
  height: 70px;
}

.settings {
  margin-top: 60px;
  margin-left: 60px;
  font-size: 23px;
  color: white;
  display: flex;
  align-items: left;
  flex-direction: column;
}

.info {
  margin-top: 20px;
}

.print-content {
  padding-left: 40px;
  margin-top: 20px;
}

.el-form /deep/ .el-form-item__label {
  font-size: 20px;
  padding: 0px;
  line-height: 40px;
}

.el-form /deep/ .el-form-item {
  margin-top: 20px;
}

.print-paper {
  width: 100%;
  border: #dcdfe6;
  border-radius: 4px;
  border-right: none;
  font-size: 30px;
  background: white;
  outline: none;
  height: 40px;
  color: #606266;
  padding-left: 15px;
}

.el-form /deep/ .el-form-item__label {
  font-size: 28px;
  padding: 0px;
  line-height: 50px;
}

.el-collapse {
  border: none;
  padding: 10px;
  padding-top: 30px;
  padding-left: 30px;
}

.el-collapse-item {
  margin-bottom: 25px;
}

.el-collapse /deep/ .el-collapse-item__content,
.el-collapse /deep/ .el-collapse-item__wrap {
  padding: 0px;
  border: none;
  background: transparent;
}

.el-collapse /deep/ .el-collapse-item__header {
  font-size: 30px;
  background: #2d3039;
  border: none;
  color: white;
}

.el-tabs {
  margin-top: 28px;
}

.el-tabs /deep/ .el-tabs__item {
  color: white;
  font-size: 28px;
  border: none;
}
.el-tabs /deep/.el-tabs__header {
  border: none;
}
.el-tabs /deep/.el-tabs__nav {
  border: none;
  border-bottom: 1px solid rgb(95, 92, 92);
}
.el-tabs /deep/ .is-active {
  color: @blue-selected-color;
}
.el-tabs /deep/ .is-top {
  text-align: center;
}
.el-tabs /deep/ .is-active::after {
  content: "✔";
}
.el-tabs /deep/ .el-tabs__item:hover {
  color: gray;
}

.logo-icon {
  margin-left: 10px;
  font-size: 40px;
  background: transparent;
  color: white;
}
/deep/.el-radio__label {
  font-size: 28px;
}
.el-radio {
  display: flex;
  align-items: center;
}
/deep/.el-radio .is-disabled {
  .el-radio__inner {
    background: gray;
  }
}
/deep/.el-radio-group {
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
}
.anonymous-containner {
  display: flex;
  flex-direction: row;
  align-content: center;
  align-items: center;
}
.radio-margin {
  margin-top: 25px;
}
</style>



// WEBPACK FOOTER //
// src/mainInterface/components/settings/PrintSettings.vue